import React, { Component } from 'react';
import { Container, Row, Col, Card, ListGroup } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Navigation from "context/nav";

import Profile from "./profile";
import Access from "components/profile/access";
import ApiKeys from "components/profile/apiKeys";
import Credentials from "components/profile/credentials";
import Limits from "components/profile/limits";
import PreferencesEditor from "components/profile/preferences";
import Admin from "./admin";

export default class UserSettings extends Component {
  render() {
    if ( !this.props.org ) {
      return (<></>);
    }

    const sectionId = this.props.match.params.sectionId || "profile";
    const canAdmin = this.props.app.api.canAdministerOrg(this.props.org);

    return (
      <>
        <Container className="blob-header-row content-row">
          <Row>
            <Col sm={3}>
              <Card>
                <ListGroup variant="flush" className="blob-settings-navigation-list">
                  {"profile" === sectionId
                    ? <ListGroup.Item active>Profile</ListGroup.Item>
                    : <Link to={Navigation.orgSettingsProfilePath(this.props.orgId)}>
                        <ListGroup.Item>Profile</ListGroup.Item>
                      </Link>
                  }
                  {canAdmin && ("access" === sectionId
                    ? <ListGroup.Item active>Access</ListGroup.Item>
                    : <Link to={Navigation.orgSettingsAccessPath(this.props.orgId)}>
                        <ListGroup.Item>Access</ListGroup.Item>
                      </Link>
                  )}
                  {canAdmin && ("api-keys" === sectionId
                    ? <ListGroup.Item active>API Keys</ListGroup.Item>
                    : <Link to={Navigation.orgSettingsApiKeysPath(this.props.orgId)}>
                        <ListGroup.Item>API Keys</ListGroup.Item>
                      </Link>
                  )}
                  {canAdmin && ("credentials" === sectionId
                    ? <ListGroup.Item active>Credentials</ListGroup.Item>
                    : <Link to={Navigation.orgSettingsCredentialsPath(this.props.orgId)}>
                        <ListGroup.Item>Credentials</ListGroup.Item>
                      </Link>
                  )}
                  {canAdmin && ("limits" === sectionId
                    ? <ListGroup.Item active>Limits</ListGroup.Item>
                    : <Link to={Navigation.orgSettingsLimitsPath(this.props.orgId)}>
                        <ListGroup.Item>Limits</ListGroup.Item>
                      </Link>
                  )}
                  {"preferences" === sectionId
                    ? <ListGroup.Item active>Preferences</ListGroup.Item>
                    : <Link to={Navigation.orgSettingsPreferencesPath(this.props.orgId)}>
                        <ListGroup.Item>Preferences</ListGroup.Item>
                      </Link>
                  }
                  {canAdmin && ("admin" === sectionId
                    ? <ListGroup.Item active>Administration</ListGroup.Item>
                    : <Link to={Navigation.orgSettingsAdminPath(this.props.orgId)}>
                        <ListGroup.Item>Administration</ListGroup.Item>
                      </Link>
                  )}
                </ListGroup>
              </Card>
            </Col>
            <Col sm={9}>
              <div className={"profile" === sectionId ? "" : "hidden"}>
                <Profile
                  history={this.props.history}
                  app={this.props.app}
                  org={this.props.org}
                  profileInterface={this.props.profileInterface}
                  readOnly={!canAdmin}
                />
              </div>
              <div className={"access" === sectionId ? "" : "hidden"}>
                <Access
                  history={this.props.history}
                  app={this.props.app}
                  profileInterface={this.props.profileInterface}
                  target={"org"}
                  targetObject={this.props.org}
                />
              </div>
              <div className={"api-keys" === sectionId ? "" : "hidden"}>
                <ApiKeys
                  history={this.props.history}
                  app={this.props.app}
                  target={"org"}
                  targetId={this.props.org.id}
                />
              </div>
              <div className={"credentials" === sectionId ? "" : "hidden"}>
                <Credentials
                  history={this.props.history}
                  app={this.props.app}
                  target={"org"}
                  targetId={this.props.org.id}
                />
              </div>
              <div className={"limits" === sectionId ? "" : "hidden"}>
                <Limits
                  history={this.props.history}
                  app={this.props.app}
                  org={this.props.org}
                  target={"org"}
                  targetIds={[this.props.org.id]}
                />
              </div>
              <div className={"preferences" === sectionId ? "" : "hidden"}>
                <PreferencesEditor
                  scope={{ orgId: this.props.org.id }}
                />
              </div>
              <div className={"admin" === sectionId ? "" : "hidden"}>
                <Admin
                  history={this.props.history}
                  app={this.props.app}
                  org={this.props.org}
                  profileInterface={this.props.profileInterface}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}
